/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {displayError} from '../../app/errorDisplayer';
import DataSourceDecoration from './DataSourceDecorationAdd.react';
import LoadingButton from '../../fw/LoadingButton.react';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import {LoadingLine} from '../../loadingLine/renderLoadingPanel.react';
import types from '../../../common/model-api/types';
import GridList from '../../fw/GridList.react';
import { Form, Select } from 'formsy-react-components';

export const handlerName = "query";

export const messages = defineMessages({
    field1: {id: 'DataSourceQuery.field1', 'defaultMessage': 'Select field'},
    field2: {id: 'DataSourceQuery.field2', 'defaultMessage': 'Select field'},
    operation: {id: 'DataSourceQuery.operation', 'defaultMessage': 'Operation'},
    save: {id: 'DataSourceQuery.save', 'defaultMessage': 'Create query'},
});

class DataSourceQueryAdd extends React.Component {

    static propTypes = {
        apply: PropTypes.func,
        dataSource: PropTypes.object,
        dataSourceToAdd: PropTypes.object,
        goBack: PropTypes.func,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.componentWillReceiveProps(props);

        this.state = {
            canSubmit: false,
        };
    }

    add = (data) => {
        let channelDef = this.props.dataSource.screen.organisation.channel.channelDef;
        let channel = this.props.dataSource.screen.organisation.channel;
        let sourceDef = channel.channelDef.sourceDef;
        let channelEntityDef = sourceDef.channelEntityDefs.edges[0].node;

        let newDataSource = {
            ...this.props.dataSourceToAdd,
            channelDef_id: channelDef.realId,
            entityDef_id: channelEntityDef.entityDef_id,
            args: {
                channelEntityDef_id: channelEntityDef.realId,
                sourceDef_id: sourceDef.realId,

                query: "SELECT * FROM [$CURRENT] as current INNER FREE JOIN [" +
                        "SOURCEDEF :sourceDefId " +
                        "ENTITYDEF :entityDefId " +
                    "] as joined " +
                    "ON current.\"" + data.select1 + "\" " + data.operation[0] + " joined.\"" + data.select2 + "\"",
                args: {
                    sourceDefId: sourceDef.realId,
                    entityDefId: channelEntityDef.entityDef_id,
                }
            }
        };

       return this.props.apply(newDataSource);
    };

    componentWillReceiveProps(props) {
        if (props.dataSource.primaryEntityDef && this.entityDef_id !== props.dataSource.primaryEntityDef.realId) {
            this.entityDef_id = props.dataSource.primaryEntityDef.realId;

            this.props.relay.setVariables({
                selectedEntityDef: true,
                entityDef_id: props.dataSource.primaryEntityDef.realId
            });
        }
    }

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    render() {
        let dataSourceToAdd = this.props.dataSourceToAdd;
        let dataSource = this.props.dataSource;

        let type = types['channels'];

        let isShowingChannel = this.props.relay.variables.channel_id ? true : false;
        let isShowingSourceDef = this.props.relay.variables.sourceDef_id ? true : false;

        let content = <LoadingLine/>;

        if (dataSource && dataSource.screen && dataSource.screen.organisation) {
            if (isShowingSourceDef && dataSource.screen.organisation.channel.channelDef.sourceDef) {
                let channelEntityDef = dataSource.screen.organisation.channel.channelDef.sourceDef.channelEntityDefs.edges.length > 0 ? dataSource.screen.organisation.channel.channelDef.sourceDef.channelEntityDefs.edges[0].node : null;

                let operation = [
                    {value: '=', label: 'equals'},
                    {value: '!=', label: 'not equals'},
                ];

                let fields1 = [{value: '', label: '-'}, ...dataSource.mappedFields.map((node) => ({value: node.realId, label: node.shortName ? node.shortName : node.name}))];
                let usedFieldDefs = channelEntityDef ? channelEntityDef.usedFieldDefs.edges.map(({node}) => ({value: node.realId, label: node.shortName ? node.shortName : node.name})) : [];
                let fields2 = [{value: '', label: '-'}, ...usedFieldDefs];

                content = (
                    <div style={{width: '100%', paddingBottom: '15em'}}>
                        <Form
                            onInvalid={this.disableButton}
                            onValid={this.enableButton}
                            onValidSubmit={this.add}
                        >
                            <Select
                                label={this.props.intl.formatMessage(messages.field1)}
                                name="select1"
                                options={fields1}
                                required
                            />
                            <Select
                                label={this.props.intl.formatMessage(messages.operation)}
                                name="operation"
                                options={operation}
                                value={["="]}
                            />
                            <Select
                                label={this.props.intl.formatMessage(messages.field2)}
                                name="select2"
                                options={fields2}
                                required
                            />

                            <LoadingButton className="btn btn-primary"
                                           disabled={!this.state.canSubmit}
                                           type="submit">{this.props.intl.formatMessage(messages.save)}</LoadingButton>
                        </Form>
                    </div>
                );
            } else if (isShowingChannel && dataSource.screen.organisation.channel) {
                content = (
                    <div>
                        <FormattedMessage defaultMessage="Choose data type:"
                                          id="DataSourceQuery.dataSource.description"/><br/>

                        <div
                            className="btn-group-vertical DataSourceRelationGroup">{dataSource.screen.organisation.channel.channelDef.sourceDefs.edges.map((node, idx) => {
                            return (
                                <LoadingButton className="btn btn-default" key={idx}
                                               onClick={() => {
                                                   let sourceDef = node.node;
                                                   this.props.relay.setVariables({
                                                       "selectedSourceDef": true,
                                                       "sourceDef_id": sourceDef.realId
                                                   });
                                               }}>
                                    <span aria-hidden="true" className="fa fa-plus fa-fw"></span>{" "}{node.node.name}
                                </LoadingButton>
                            );
                        })}
                        </div>
                    </div>
                );
            } else if (!isShowingChannel && !isShowingSourceDef && dataSource.screen.organisation.channels) {
                content = (
                    <div>
                        <div className="sectionHeader">
                            <h3><FormattedMessage defaultMessage="Choose connected application:" id="DataSourceQuery.chooseApplication.description"/><br/></h3>
                        </div>

                        <GridList
                            bothTitles
                            edges={dataSource.screen.organisation.channels}
                            iconProperty="channelDef.icon"
                            metadata={type}
                            onClick={(item, event) => {
                                this.props.relay.setVariables({
                                    "selectedChannel": true,
                                    "channel_id": item.realId
                                });
                            }}
                            relay={this.props.relay}
                            titleProperty="name"
                            titleProperty2="channelDef.name"
                        />
                    </div>
                );
            }
        }

        try {
            return (
                <DataSourceDecoration
                    dataSource={dataSource}
                    dataSourceToAdd={dataSourceToAdd}
                    goBack={this.props.goBack}
                >

                    <div style={{padding: '2em'}}>
                        {content}
                    </div>
                </DataSourceDecoration>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}


export default Relay.createContainer(injectIntl(DataSourceQueryAdd), {
    initialVariables: {
        selectedChannel: false,
        channel_id: null,
        selectedSourceDef: false,
        sourceDef_id: null,
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    mappedFields {
                        id,
                        realId,
                        name,
                        shortName,
                    },
                    channelDefs {
                        id,
                        name,
                        icon,
                    },
                    screen {
                        id,
                        organisation {
                            id,
                            channel(id: $channel_id) @include(if: $selectedChannel) {
                                id,
                                realId,
                                channelDef {
                                    id,
                                    realId,
                                    name,
                                    sourceDef(id: $sourceDef_id) @include(if: $selectedSourceDef) {
                                        id,
                                        realId,
                                        name,
                                        channelEntityDefs(first: 1) {
                                            edges {
                                                node {
                                                    id,
                                                    realId,
                                                    entityDef_id,
                                                    usedFieldDefs(first: 200) {
                                                        edges {
                                                            node {
                                                                id,
                                                                realId,
                                                                name,
                                                                shortName,
                                                                key,
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    sourceDefs(first: 100) {
                                        edges {
                                            node {
                                                id,
                                                realId,
                                                name,
                                            }
                                        }
                                    }
                                },
                            },
                            channels(first: 100, deleted: false) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        organisation_id,
                                        name,
                                        channelDef {
                                            id,
                                            name,
                                            icon,
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;
        }
    }
});
